import { ModelosByTipoQuery } from 'graphql/types.generated'

export type ModeloPersonalizadoSelectFieldModel = ModelosByTipoQuery['modelosPersonalizadosByTipoModulo'][0]

export interface ModeloPersonalizadoModel extends ModeloPersonalizadoSelectFieldModel {
  hasCampoInconsistente?: boolean
}

export const modeloPersonalizadoToString = (modelo: ModeloPersonalizadoSelectFieldModel) => modelo?.nome
